module.exports = __webpack_public_path__ + "img/フォルクスワーゲン.d12537a5.png";